/*
 * Bundle cart sync
 *
 * Keeps bundle component quantities in step with their parent, in both directions.
 * Take the main product to 2 and every component it was bundled with becomes 2;
 * step it back down and they follow; remove the parent and the whole group goes.
 *
 * Both the quantity selector and the remove link reach the cart through
 * theme.cart.changeItem(key, qty), which talks to /cart/change.js and can only
 * move one line. So changeItem is wrapped: for a bundle parent it sends a single
 * /cart/update.js carrying the parent and every component instead.
 *
 * That swap is invisible to the callers. changeItem resolves with the cart object
 * and so does /cart/update.js, so theme.js keeps rebuilding the cart and firing
 * cart:updated exactly as before — one request, one repaint, and no window where
 * a parent and its components disagree.
 *
 * Rows carry what this needs from snippets/cart-item.liquid:
 *   data-key             line item key, on every row
 *   data-bundle-id       on a parent
 *   data-bundle-parent   on a component, matching its parent's id
 */
(function () {
  function keyFor(row) {
    return row.getAttribute('data-key');
  }

  // Components are matched by attribute value rather than a selector, so a key
  // containing quotes or colons cannot break the query.
  function componentKeysFor(bundleId) {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-bundle-parent]'))
      .filter(function (row) {
        return row.getAttribute('data-bundle-parent') === bundleId;
      })
      .map(keyFor)
      .filter(Boolean);
  }

  function bundleIdForKey(key) {
    var rows = document.querySelectorAll('[data-bundle-id]');

    for (var i = 0; i < rows.length; i++) {
      if (keyFor(rows[i]) === key) return rows[i].getAttribute('data-bundle-id');
    }

    return null;
  }

  function updateUrl() {
    // Derived from the change route so any locale prefix is preserved.
    var change = (window.theme && theme.routes && theme.routes.cartChange) || '/cart/change.js';
    return change.replace('/change.js', '/update.js');
  }

  function wrapChangeItem() {
    if (!window.theme || !theme.cart || typeof theme.cart.changeItem !== 'function') return false;
    if (theme.cart.changeItem.bundleAware) return true;

    var original = theme.cart.changeItem;

    var wrapped = function (key, qty) {
      var bundleId = bundleIdForKey(key);
      if (!bundleId) return original.call(this, key, qty);

      var componentKeys = componentKeysFor(bundleId);
      if (!componentKeys.length) return original.call(this, key, qty);

      // Every line in the group moves to the same quantity, parent included, so
      // qty 0 from the remove link clears the whole bundle.
      var updates = {};
      updates[key] = qty;
      componentKeys.forEach(function (componentKey) {
        updates[componentKey] = qty;
      });

      return theme.cart._updateCart({
        url: updateUrl() + '?t=' + Date.now(),
        data: JSON.stringify({ updates: updates }),
      });
    };

    wrapped.bundleAware = true;
    theme.cart.changeItem = wrapped;

    return true;
  }

//   // theme.js is deferred, so it has normally run by now. The listener is the
//   // fallback for any load order where it has not.
//   if (!wrapChangeItem()) {
//     document.addEventListener('DOMContentLoaded', wrapChangeItem);
//   }
// })();


/* ==========================================================================
     Cart badge count

     A four-slot bundle is five cart lines, so cart.item_count reads as five when
     the customer chose one bundle. The parent is the container those components
     were chosen through, so its quantity is left out of the badge.

     This mirrors the Liquid in snippets/header-icons.liquid, which handles the
     first paint. This copy handles every AJAX cart update after it.
     ========================================================================== */

  function adjustedCount(cart) {
    if (!cart || !cart.items) return 0;

    var parentUnits = {};
    var hasComponents = {};

    cart.items.forEach(function (item) {
      var properties = item.properties || {};

      if (properties._bundle_id) {
        parentUnits[properties._bundle_id] =
          (parentUnits[properties._bundle_id] || 0) + item.quantity;
      }

      if (properties._bundle_parent) {
        hasComponents[properties._bundle_parent] = true;
      }
    });

    var deduct = 0;
    Object.keys(parentUnits).forEach(function (id) {
      // A parent left without its components still counts as one item.
      if (hasComponents[id]) deduct += parentUnits[id];
    });

    return Math.max(0, cart.item_count - deduct);
  }

  function paintBadge(cart) {
    var count = adjustedCount(cart);

    document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
      // The count sits directly in the bubble in this theme, so only the text
      // node is replaced to leave any icon markup alone.
      bubble.textContent = count;
      bubble.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) paintBadge(event.detail.cart);
  });

  // theme.js is deferred, so it has normally run by now. The listener is the
  // fallback for any load order where it has not.
  if (!wrapChangeItem()) {
    document.addEventListener('DOMContentLoaded', wrapChangeItem);
  }

  // Exposed so the inline cart-count refresh in layout/theme.liquid can use the
  // same arithmetic instead of a second copy of it.
  window.theme = window.theme || {};
  window.theme.bundleAdjustedCartCount = adjustedCount;
})();
